export const REGISTER_USER = "registerUser";
export const LOGIN_USER = "loginUser";
export const CHECK_USER = "checkUSer";